import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Paper, Typography, makeStyles } from '@material-ui/core';
import { updateSaleScopeById } from 'store/actions/sales';
import { PLAN_ANALISE } from 'helpers/process.helper';

// O que está sendo vendido, escolhido ANTES de cadastrar português e
// processos (pedido dos vendedores, 29/10/2026). Só muda o plano da venda
// (o mesmo campo do passo 4); o resto do escopo segue igual. Para a
// Análise, o cadastro dos processos é o mínimo: fases e apenso ficam para
// a continuação.

const useStyles = makeStyles((theme) => ({
  grade: { display: 'grid', gridTemplateColumns: '1fr', gap: 12, [theme.breakpoints.up('sm')]: { gridTemplateColumns: '1fr 1fr' } },
  opcao: {
    cursor: 'pointer', padding: theme.spacing(2), border: '2px solid #E4E3E9', borderRadius: 12, textAlign: 'left',
    background: '#fff', font: 'inherit', width: '100%',
    '&:hover': { borderColor: '#1F9833' },
  },
  ativa: { borderColor: '#1F9833', background: '#E8F5EA' },
  titulo: { fontWeight: 900, fontSize: 16, margin: 0 },
  sub: { color: '#64688B', fontSize: 13.5, margin: '4px 0 0' },
  dica: { color: '#64688B', fontSize: 13, marginTop: 8 },
}));

const OPCOES = [
  { valor: PLAN_ANALISE, titulo: 'Plano Análise', sub: 'R$ 1.000 + R$ 500 por requerente adicional. Vai até o laudo; a continuação é vendida depois, com abatimento.' },
  { valor: 'PLAN_2026', titulo: 'Assessoria completa', sub: 'O processo completo, pela tabela por adultos. Certidões e vale postal ficam fora.' },
];

function PlanoDaVenda({ scope, updateScope }) {
  const classes = useStyles();
  const [plano, setPlano] = useState(scope.family_plan);
  if (process.env.REACT_APP_PLANO_ANALISE !== '1' || !scope || scope.confirmed) return null;

  const escolher = (valor) => {
    if (valor === plano) return;
    setPlano(valor);
    updateScope(scope.id, scope.client_id, { family_plan: valor });
  };

  return (
    <>
      <Typography variant="h5" paragraph>O que você está vendendo?</Typography>
      <Paper elevation={3} style={{ padding: 16, marginBottom: 24 }}>
        <div className={classes.grade} role="radiogroup" aria-label="Plano da venda">
          {OPCOES.map((o) => (
            <button
              type="button"
              key={o.valor}
              role="radio"
              aria-checked={plano === o.valor}
              className={`${classes.opcao} ${plano === o.valor ? classes.ativa : ''}`}
              onClick={() => escolher(o.valor)}
            >
              <p className={classes.titulo}>{o.titulo}</p>
              <p className={classes.sub}>{o.sub}</p>
            </button>
          ))}
        </div>
        <p className={classes.dica}>
          {plano === PLAN_ANALISE
            ? 'Na Análise, cadastre o português e cada requerente com o processo dele. Fases e apenso ficam para a continuação; a procuração sai da lista sozinha ao assinar.'
            : 'O plano também pode ser trocado no passo 4 (Pagamento).'}
        </p>
      </Paper>
    </>
  );
}

const mapStateToProps = (state) => ({ scope: state.sales.scope });

export default connect(mapStateToProps, { updateScope: updateSaleScopeById })(PlanoDaVenda);
